import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {styled, TableCell, tableCellClasses, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function ContributionFieldFailureDialog(props) {
    const setFieldFailureDialogOpen = props.setFieldFailureDialogOpen;
    const fieldFailureDialogOpen = props.fieldFailureDialogOpen;
    const fieldFailureMap = props.fieldFailureMap;

    const handleClose = () => {
        setFieldFailureDialogOpen(false);
    };

    return (
        <div>
            {fieldFailureMap &&
                <Dialog
                    open={fieldFailureDialogOpen}
                    onClose={handleClose}
                    aria-labelledby="externalSourceQueryInfo-dialog-title"
                    aria-describedby="externalSourceQueryInfo-dialog-description"
                    maxWidth='md'
                >
                    <DialogTitle id="externalSourceQueryInfo-dialog-title">
                        Validation Issue Counts by Field
                    </DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650, m: 0}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell sx={{width: 400}}>Field Name</StyledTableCell>
                                        <StyledTableCell>Counts</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.entries(fieldFailureMap).map(([key, value], i) => (
                                        <StyledTableRow
                                            key={i}
                                        >
                                            <StyledTableCell component="th" scope="row">
                                                {key}
                                            </StyledTableCell>
                                            <StyledTableCell>{value}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </DialogContent>
                    <DialogActions sx={{display: 'flex', justifyContent: 'center', padding: '0 8px 12px 8px'}}>
                        <Button onClick={handleClose} autoFocus variant='contained'>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </div>
    );
}
